import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, Routes, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AppInitializerService, LoginGuard } from '@simac/ui';

export const routes: Routes = [
  {
    path: 'home',
    title: 'Home',
    loadComponent: () => import('./core/home/pages/home.component').then((m) => m.HomeComponent),
    canActivate: [LoginGuard],
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  { path: '**', redirectTo: 'home' },
];

export class TemplatePageTitleStrategy extends TitleStrategy {
  constructor(
    private readonly initializerService: AppInitializerService,
    private readonly title: Title,
    private readonly translateService: TranslateService,
  ) {
    super();
  }

  override updateTitle(routerState: RouterStateSnapshot) {
    let title = this.buildTitle(routerState);
    if (title?.includes('.')) {
      title = this.translateService.instant(title);
    }
    if (title !== undefined) {
      this.title.setTitle(`${this.initializerService.appinfo?.title} | ${title}`);
    }
  }
}
